import {Component, Input, ChangeDetectionStrategy} from "@angular/core";
import {Location} from "@angular/common";
import {PerformaInfoService} from "src/app/services/performa-info.service";
import {AuthService} from "src/app/services/auth.service";

@Component({
    selector: "app-error",
    templateUrl: "./error.component.html",
    styleUrl: "./error.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorComponent {
    @Input() page = "";

    constructor(
        public readonly infoService: PerformaInfoService,
        public readonly authService: AuthService,
        private locationObj: Location
    ) {}

    curYear: string = new Date().getFullYear().toString();

    back = () => {
        if (this.page == "invalid") {
            // do we know where they came from?
            if (this.infoService.errorPath) {
                window.location.href = this.infoService.errorPath;
            }

            // default to going to the previous page
            this.locationObj.back();
            return;
        }
        window.location.href = "/";
    };
}
